import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";

const AdminLoginPage: React.FC = () => {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const location = useLocation() as any;
  const from = location?.state?.from?.pathname || "/admin";

  const [kullaniciAdi, setKullaniciAdi] = useState("");
  const [sifre, setSifre] = useState("");
  const [err, setErr] = useState<string>();
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setErr(undefined);
      setLoading(true);
      await login(kullaniciAdi, sifre);
      nav(from, { replace: true });
    } catch (ex: any) {
      setErr(ex?.message ?? "Giriş başarısız.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-zinc-50">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white border border-zinc-200 p-6 rounded-lg shadow-sm space-y-3"
      >
        <h1 className="text-2xl font-semibold text-center mb-3">🔐 Admin Giriş</h1>

        <div>
          <label className="text-sm text-zinc-700">Kullanıcı Adı</label>
          <input
            className="border rounded w-full p-2 mt-1 focus:ring-2 focus:ring-indigo-500 outline-none"
            placeholder="Kullanıcı Adı"
            value={kullaniciAdi}
            onChange={(e) => setKullaniciAdi(e.target.value)}
          />
        </div>

        <div>
          <label className="text-sm text-zinc-700">Şifre</label>
          <input
            className="border rounded w-full p-2 mt-1 focus:ring-2 focus:ring-indigo-500 outline-none"
            placeholder="Şifre"
            type="password"
            value={sifre}
            onChange={(e) => setSifre(e.target.value)}
          />
        </div>

        {err && <div className="text-sm text-red-600">{err}</div>}

        <button
          disabled={loading}
          className="w-full py-2 mt-2 rounded bg-indigo-600 hover:bg-indigo-700 text-white font-medium transition disabled:opacity-50"
        >
          {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>


      </form>
    </div>
  );
};

export default AdminLoginPage;
